import { useEffect, useState } from "react";

interface Props {
  targetName: string;
  onComplete?: () => void;
}

export function WarpTransition({ targetName, onComplete }: Props) {
  const [phase, setPhase] = useState<"charge" | "streak" | "arrive">("charge");

  useEffect(() => {
    const t1 = setTimeout(() => setPhase("streak"), 600);
    const t2 = setTimeout(() => setPhase("arrive"), 1600);
    const t3 = setTimeout(() => onComplete?.(), 2200);
    return () => { clearTimeout(t1); clearTimeout(t2); clearTimeout(t3); };
  }, [onComplete]);

  return (
    <div className={`warp-transition warp-phase-${phase}`}>
      <div className="warp-stars">
        {Array.from({ length: 60 }).map((_, i) => (
          <div
            key={i}
            className="warp-star-line"
            style={{
              top: `${Math.random() * 100}%`,
              left: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 0.5}s`,
              transform: `rotate(${Math.random() * 360}deg)`,
            }}
          />
        ))}
      </div>
      <div className="warp-flash" />
      <div className="warp-text">
        {phase === "charge" && (
          <span className="warp-status">ENGAGING WARP DRIVE</span>
        )}
        {phase === "streak" && (
          <span className="warp-status warp-status-fast">IN TRANSIT</span>
        )}
        {phase === "arrive" && (
          <span className="warp-status">ARRIVING AT {targetName.toUpperCase()}</span>
        )}
      </div>
    </div>
  );
}
